var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column justify-center align-center",
    staticStyle: {
      "height": "calc(90%)"
    }
  }, [_c('lottie-animation', {
    ref: "animation",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "animationData": _vm.errorAnimation,
      "autoPlay": false
    }
  }), _c('v-fade-transition', [_vm.show ? _c('div', {
    staticClass: "pa-4 d-flex flex-column align-center text-center"
  }, [_c('div', {
    staticClass: "text-h4"
  }, [_vm._v("Oops")]), _c('div', {
    staticClass: "text-body-1 mt-4"
  }, [_vm._v(_vm._s(_vm.$t('CurrentlyNotAcceptingOrders')))])]) : _vm._e()])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }